import { createPortal } from "react-dom";
import Div from "../Div";
import FormButton from "../FormButton";
import TabView from "./TabView";
import { useCallback, useEffect, useState } from "react";
import ResellerCustomerList from "./ResellerCustomerList";
import { getDomainContactDetailsShiviom, getDomainContactDetails } from "../../http/CentralizedDataHttp";
// import { useState } from "react";

function DomainDetailModal({ domain_name, email, reseller, handleClicked, ...props }) {

    const [domainDetails, setDomainDetails] = useState([])

    function handleClose() {
        handleClicked(false);
    }

    const getDomainContactDetail = useCallback(async () => {
        
        if (reseller) {
            const response = await getDomainContactDetailsShiviom(email)
            setDomainDetails(response.domain)
        }
        else {
            const response = await getDomainContactDetails(domain_name)
            if (!response) {
                setDomainDetails([])
            } else {
                setDomainDetails(response.domains)
            }

        }


    }, [email, domain_name, reseller])


    useEffect(() => {
        getDomainContactDetail()
    }, [getDomainContactDetail])

    return (
        <>
            {createPortal(
                <Div className="modal-backdrop">
                    <dialog {...props} style={{ zIndex: '1', width: '90%', marginTop: '5%', overflowY: 'scroll', maxHeight: '80%'  }}>

                        <Div className="form-group">{reseller ? 'Reseller' : 'Domain'} Details for {domain_name}</Div>

                        {reseller ? <Div>
                            <Div className='row'>
                                <Div className='col-sm-12 text-center justify-content-center'>
                                    <strong>Reseller Contact Details</strong>
                                </Div>
                            </Div>
                        </Div>

                            :
                            <Div>
                                <Div className='row'>
                                    <Div className='col-sm-12 text-center justify-content-center'>
                                        <strong>Customer Contact Details</strong>
                                    </Div>
                                </Div>
                            </Div>}

                        {reseller ?
                            <Div>
                                <Div className='row' style={{ marginTop: '30px', marginLeft: '10px' }}>
                                    <Div className='col-sm-4 text-left justify-content-center'>
                                        <strong>Reseller Name :</strong>  {domainDetails[0] ? domainDetails[0]?.reseller_name : null}
                                    </Div>

                                    <Div className='col-sm-4 text-left justify-content-center'>
                                        <strong>Reseller Email :</strong>  {email}
                                    </Div>

                                    <Div className='col-sm-4'>
                                        <strong>Reseller Company Name :</strong>  {domainDetails[0] ? domainDetails[0]?.company_name : null}
                                    </Div>
                                </Div>
                                <Div className='row' style={{ marginTop: '30px', marginLeft: '10px' }}>

                                    <Div className='col-sm-4 text-left justify-content-center'>
                                        <strong>Phone Number :</strong>  {domainDetails[0] ? domainDetails[0]?.phone_number : null}
                                    </Div>
                                    <Div className='col-sm-4 text-left justify-content-center'>
                                        <strong>GST Number :</strong>  {domainDetails[0] ? domainDetails[0]?.gst_number : null}
                                    </Div>
                                    <Div className='col-sm-4'>
                                        <strong>Customer Domain Count :</strong>  {domainDetails[0] ? domainDetails[0]?.customer_domain_count : null}

                                    </Div>
                                </Div>
                            </Div> :
                            <Div>
                                <Div className='row' style={{ marginTop: '30px', marginLeft: '10px' }}>
                                    <Div className='col-sm-4 text-left justify-content-center'>
                                        <strong>Name :</strong>  {domainDetails[0] ? domainDetails[0]?.customer_name : null}
                                    </Div>

                                    <Div className='col-sm-4 text-left justify-content-center'>
                                        <strong>Email :</strong>  {domainDetails[0] ? domainDetails[0]?.contact_details_email : null}
                                    </Div>

                                    <Div className='col-sm-4'>
                                        <strong>Company Name :</strong>  {domainDetails[0] ? domainDetails[0]?.company_name : null}
                                    </Div>
                                </Div>
                                <Div className='row' style={{ marginTop: '30px', marginLeft: '10px' }}>

                                    <Div className='col-sm-4 text-left justify-content-center'>
                                        <strong>Phone Number :</strong>  {domainDetails[0] ? domainDetails[0]?.cont_number : null}
                                    </Div>
                                    <Div className='col-sm-4 text-left justify-content-center'>
                                        <strong>GST Number :</strong>  {domainDetails[0] ? domainDetails[0]?.gst_number : null}
                                    </Div>
                                    <Div className='col-sm-4 text-left justify-content-center'>
                                        <strong>Domain Type :</strong>  {domainDetails[0]?.resellerType === 'Reseller' ? 'Reseller' : 'Customer'}
                                    </Div>
                                </Div>
                                <Div className='row'  style={{ marginTop: '30px', marginLeft: '10px' }}>
                                <Div className='col-sm-4 text-left justify-content-center'>               
                                    <strong>Segment :</strong>  {domainDetails[0] ? domainDetails[0]?.segments : null}
                                    </Div>
                                </Div>
                            </Div>}


                        {reseller ?
                            <>
                                <Div className='row' style={{ marginTop: '30px', marginLeft: '10px' }}>

                                    <Div className='col-sm-12 text-left justify-content-center'>
                                        <strong>Customer Domain List</strong>
                                    </Div>
                                </Div>

                                <ResellerCustomerList domain_name={domain_name} style={{ marginTop: '30px', marginLeft: '10px', overflowY: 'scroll', maxHeight: '300px' }} />
                            </>
                            :
                            <TabView domain_name={domain_name} />}

                        <Div className="form-group">
                            <Div className='row'>
                                <Div className='col-sm-2' style={{ marginTop: '15px' }}>
                                    <FormButton type='button' onClick={handleClose} style={{ margin: '2px' }} className="btn btn-primary submit-btn btn-block" >Close</FormButton>
                                </Div>
                            </Div>

                            <Div className='row'>
                                <Div className='col-sm-12'>
                                    {/* {error ?  <p style={{color:'red',marginLeft: '15px', marginTop:'4px'}}> {error}</p> : null } */}
                                </Div>
                            </Div>
                        </Div>

                    </dialog>

                </Div>
                , document.getElementById('modal'))

            }
        </>
    )
}

export default DomainDetailModal;